import React from 'react';
import Head from 'next/head';
import Layout from '../components/layout';
import Container from '../components/container';
import NavBar from '../components/navbar';
import config from '../lib/config';

import { GetStaticProps } from 'next';
import { fetchAPI, getPrimaryMenuItems } from '../lib/api';
import { H2 } from '../components/text';
import { ISponsor } from '../models/sponsor';
import { IPage } from '../models/page';
import { IMenuItem } from '../models/menu-item';
import { VideoCategorySlider } from '../components/video-category-slider';
import { ICategoryVideo } from '../models/category-video';

import 'swiper/css';

interface IProps {
	allCategories: ICategoryVideo[];
	primaryMenuItems: IMenuItem[];
	pageData: IPage;
	sponsors: ISponsor[];
}

export default function GoalOfTheWeeksPage({ allCategories, primaryMenuItems, pageData: { page }, sponsors }: IProps) {
	const pageTitle = `${page.title} | ${config.siteName}`;
	const meta = page.seo?.description || page.title;

	return (
		<Layout preview customClass="bg-kkd-dark" sponsors={sponsors} metaTitle={pageTitle} metaDesc={meta}>
			<Head>
				<title>{pageTitle}</title>
			</Head>
			<NavBar items={primaryMenuItems} />
			<Container className="py-14">
				<div className="flex items-center gap-4 mb-12">
					<H2 className="text-white">Doelpunt van de Week</H2>
				</div>

				<div className="flex flex-col gap-12 lg:gap-20">
					{allCategories.map((category) => (
						<VideoCategorySlider
							key={category.name}
							data={category.posts.nodes}
							title={category.name}
							baseSlug="doelpunt-van-de-week"
						/>
					))}
				</div>
			</Container>
		</Layout>
	);
}

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
	const primaryMenuItems = await getPrimaryMenuItems();
	const pageData = await fetchAPI<{ sponsors: { nodes: any[] } }>(`
		query {
			page(id: 111880, idType: DATABASE_ID) {
				title
				content
			}
			sponsors {
				nodes {
					title
					sponsor_fields {
						subtitle
						websiteUrl
						mainSponsor
						invertedImage {
							sourceUrl
						}
					}
				}
			}
		}
	`);

	const allCategories = await fetchAPI<{ categories: { nodes: any[] } }>(`
		query getAllCategories {
			categories(first: 10, where: { parent: 57, order: DESC, orderby: TERM_ID }) {
				nodes {
					name
					posts (first: 40) {
						nodes {
							title
							slug
							date
							featuredImage {
								node {
									sourceUrl
								}
							}
							videoLinks {
								youtubeLink
								fieldGroupName
							}
						}
					}
				}
			}
		}
	`);

	const filteredCategories = allCategories.categories.nodes.filter((category) => category.posts.nodes.length);

	return {
		props: {
			allCategories: filteredCategories,
			sponsors: pageData.sponsors.nodes,
			pageData,
			preview,
			primaryMenuItems,
		},
		revalidate: 300,
	};
};
